export const environment = {
  production: false,
  gTagManagerCode: 'GTM-KZ93DWH',
  wootricCsat: "eb67c1d7",
  wootricCes: "16ddf57c",
  wootricDev: true,
  urlApiNmp: 'https://qa-api-nmp.azurewebsites.net/',
  urlMarketplaceCore: 'https://dev-apim-ic.azure-api.net/nmp-sso/',
  url: "https://qa-api-cotizaciones.azurewebsites.net/",
  urlMarketplace: "https://apimarketplace-des.iconstruye.cl/",
  urlArchivo: "https://qa-api-archivos.azurewebsites.net/",
  urlEmpresa: "https://qa-api-consulta-emp.azurewebsites.net",
  instrumentationKey: '2d762043-d274-474b-be04-6b9e5c49e455',
  urlApiHook: 'https://qa-api-nmp-hook.azurewebsites.net/',
  urlJwtMetabase: 'https://qa-api-metabase.azurewebsites.net/',
  urlApiSSO: 'https://qa-api-login.azurewebsites.net/',
  domainCookie: 'iconstruye.cl',
  ulrDashboard: 'https://marketplacessoqa.iconstruye.cl/',
  urlApiConfiguracion :'https://qa-api-gateway.iconstruye.cl/configuracion/',
  urlApiCompra :'https://qa-api-gateway.iconstruye.cl/compra/',
  // ApiBasicUser : "AppApiCompra",
  // ApiBasicPassword : "0sk5QdFyg7*j",
  //UseBasic: true
  apiLocal: false,
  // Red de emergencia: SOLO se usa cuando Unleash no contesta. Dejar en `false`; en `true`
  // el flag quedaría imposible de apagar desde la consola con Unleash caído.
  flags: { 'cotizaciones-prueba-unleash': false } as Record<string, boolean>,
  // Feature flags (proyecto Unleash `portal-proveedores-cotizaciones`, ambiente qa).
  // `url`/`clientKey` vacíos => no se llama a Unleash y manda `flags`. El token de
  // Frontend API es público por diseño: viaja igual al navegador.
  unleash: {
    url: 'https://us.app.unleash-hosted.com/usnn0072/api/frontend',
    clientKey: 'portal-proveedores-cotizaciones:qa.v2_SBtiXiXAGRbOVJZND2L_sA_zHtBnbYv5r7SYNkKK0jLDlRpu0wICUMhTMlPM_06Qtc',
    appName: 'iccorp-cotizaciones-scm-front-web',
    refreshInterval: 60,
    timeoutMs: 2500
  }
};

